import { css } from "lit"

export const tertiaryStyles = css`
  /* Tertiary footer */
  .tertiary {
    padding: 0 1.25rem 2rem;
  }

  .tertiary-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1.75rem;
  }

  .tertiary-message {
    font-size: 0.875rem;
    line-height: 1.5rem;
    max-width: 16rem;
  }

  .tertiary-message a {
    color: #647a1c;
  }

  .social-links {
    display: flex;
    gap: 1.5rem;
    align-items: center;
  }

  .social-link {
    display: block;
  }

  .social-icon {
    width: 1.25rem;
    height: 1.25rem;
    fill: #959595;
  }

  .social-icon:hover {
    fill: #647a1c;
  }

  .legal-links {
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 1rem;
    font-size: 0.625rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .legal-link {
    color: inherit;
    text-decoration: inherit;
    font-family:
      Avenir LT W01_85 Heavy1475544,
      Avenir,
      sans-serif;
    font-weight: 500;
  }

  .legal-link:hover {
    color: #647a1c;
  }

  .legal-separator {
    display: none;
  }

  .copyright {
    font-size: 0.625rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 500;
    color: #6b7280;
  }

  @media (min-width: 768px) {
    .tertiary-message {
      max-width: none;
    }

    .legal-links {
      flex-direction: row;
      align-items: center;
      gap: 0rem;
      justify-content: center;
    }

    .legal-separator {
      display: inline-block;
      width: 1px;
      height: 0.5rem;
      background: #e5e7eb;
      margin: 0 1.5rem;
    }
  }

  @media (min-width: 1024px) {
    .tertiary-container {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .tertiary-message {
      text-align: left;
    }

    .social-links {
      width: 33.333333%;
      justify-content: flex-end;
    }

    .legal-links {
      justify-content: flex-end;
      text-align: right;
      order: 9999;
    }

    .copyright {
      text-align: left;
    }
  }
`
